import type { CustomerStory } from '../../types/story'
import { retailStories } from './retailStories'
import { otherStories } from './otherStories'

/** All customer stories. The first is featured on the library page. Result numbers are placeholders until confirmed. */
export const customerStories: CustomerStory[] = [...retailStories, ...otherStories]

export const featuredStorySlug = 'all-in-one-supermarket'

export const storyLibraryStats = [
  { value: '10,000+', label: 'businesses signed up' },
  { value: '8,000+', label: 'active every month' },
  { value: 'RWF 10B+', label: 'processed each year' },
]
